import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const colabsSlice = createSlice({
  name: 'colaboradores',
  initialState: {
    data: [],
    invitacion: null,
    colab: null
  },
  reducers: {
    setColabs: (state, { payload }) => {
      state.data = payload;
    },
    setInvitacion: (state, { payload }) => {
      state.invitacion = payload;
    },
    setColab: (state, { payload }) => {
      state.colab = payload;
    }
  }
});

export const { setColabs, setInvitacion, setColab } = colabsSlice.actions;

export const getColabs = () => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/users/collab-users/`
    );

    dispatch(setColabs(data));
  } catch (e) {
    console.log(e);
  }
};

export const createColab = userData => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/create-user/`,
      userData
    );

    messageHandler('success', response?.data?.message);
    return response;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e;
  }
};

export const confirmAccount = userData => async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_SERVER}/users/verify-user`,
      userData
    );

    messageHandler(
      'success',
      'La cuenta ha sido confirmada, ya puede ingresar a la plataforma'
    );
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const getInvitation = token => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/invitations/${token}`
    );

    dispatch(setInvitacion(data));
  } catch (e) {
    console.log(e);
  }
};

export const editProfile = (id, changes) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/edit-profile/${id}`,
      changes
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

export const changePassword = (id, changes) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/edit-profile/${id}`,
      changes
    );

    messageHandler('success', response?.data?.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    throw Error(e.response.status);
  }
};

export const changePasswordInApp =
  (id, { actualPassword, newPassword }) =>
  async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}/users/change-password/${id}`,
        { oldPassword: actualPassword, newPassword }
      );

      messageHandler('success', response?.data?.message);
      return response.status;
    } catch (e) {
      messageHandler('error', e.response?.data?.message);
      return e.response.status;
    }
  };

export const resendInvitation = data => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/resend-confirmation`,
      data
    );
    messageHandler('success', response?.data?.message);
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const editCollabData = (id, data) => async () => {
  try {
    //Objeto de datos personales y su peticion
    const newData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      dni: data.dni
    };

    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/edit-data/${id}`,
      newData
    );

    messageHandler('success', response?.data?.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const editCollabRole =
  (id, { branchOfficeId, roleId, active }) =>
  async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}/users/edit-roles/${id}`,
        {
          branchOfficeId: branchOfficeId,
          roleId: roleId === null ? 0 : roleId,
          active: active
        }
      );

      messageHandler('success', 'Los roles han sido actualizados');

      return response.status;
    } catch (e) {
      messageHandler('error', e.response?.data?.message);
    }
  };

export const deleteCollab = id => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/users/${id}`
    );

    messageHandler('success', response?.data?.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response.status;
  }
};

export const activeCollab = id => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/active-user/${id}`
    );

    messageHandler('success', response?.data?.message);
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const changeCollabStatus = (id, status) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/edit-data/${id}`,
      { status: status }
    );

    messageHandler('success', response?.data?.message);
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const getCollabById = (id, setLoading) => async dispatch => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/users/${id}`
    );

    dispatch(setColab(response.data));
    setLoading && setLoading(false);
    return response.data;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const GetRecoveryPassword = email => async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_SERVER}/users/send-recovery-token`,
      { email }
    );

    messageHandler(
      'success',
      `Un enlace para restablecer su contraseña fue enviado a su correo. Tiene 24hs para actualizarla.`
    );
  } catch (e) {
    console.log(e);
    messageHandler('error', e.response?.data?.message);
  }
};

export const recoveryPassword = data => async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_SERVER}/users/recovery-password`,
      data
    );

    messageHandler(
      'success',
      `¡Constraseña reestablecida! Ya podés ingresar nuevamente a la plataforma.`
    );
  } catch (e) {
    console.log(e);
    messageHandler('error', e.response?.data?.message);
  }
};

export const uploadProfilePicture = (id, formData) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/users/upload-user-photo/${id}`,
      formData
    );

    // localStorage.setItem('token_A', response.data.token);
    // setCurrentUser(decode(response.data.token));
    return response;
  } catch (e) {
    console.log(e);
    messageHandler('error', e.response?.data?.message);
  }
};

export default colabsSlice.reducer;
